import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'
import { dateTimeToView } from 'utils/date.utils'

// รับ templateTypes และ t เป็นพารามิเตอร์
export async function exportTemplateTypesToExcel(templateTypes: any[], t: (key: string) => string, filter: any) {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(t('TEMPLATE_TYPE.TITLE'), { pageSetup: { orientation: 'landscape' } })
    // กำหนดความกว้างของคอลัมน์
    ws.columns = [
        { header: t('TABLE.NO'), key: 'no', width: 6 },
        { header: t('TEMPLATE_TYPE.TABLE.CELL.TEMPLATE_TYPE_NAME'), key: 'templateTypeName', width: 30 },
        { header: t('TEMPLATE_TYPE.TABLE.CELL.TEMPLATE_TYPE_NAME_EN'), key: 'templateTypeNameEn', width: 30 },
        { header: t('TEMPLATE_TYPE.TABLE.CELL.STATUS'), key: 'status', width: 15 },
        { header: t('TEMPLATE_TYPE.TABLE.CELL.UPDATED_BY'), key: 'updatedBy', width: 30 },
    ]

    // Title
    ws.mergeCells(1, 1, 1, ws.columns.length)

    const titleRow = ws.getCell(1, 1)
    titleRow.value = t('TEMPLATE_TYPE.TITLE')
    titleRow.font = { size: 16, bold: true }
    titleRow.alignment = { horizontal: 'center', vertical: 'middle' }

    const filterRow = ws.getRow(2)
    let statusText = t('STATUS.ALL')
    if (filter.status === 'ACTIVE') {
        statusText = t('STATUS.ACTIVE')
    } else if (filter.status === 'INACTIVE') {
        statusText = t('STATUS.INACTIVE')
    }
    const filterText = `${t('INPUT.SEARCH')}: ${filter.search || '-'}   ${t('STATUS.LABEL')}: ${statusText}`
    const filterCell = filterRow.getCell(1)
    filterCell.value = filterText
    ws.mergeCells(filterRow.number, 1, filterRow.number, ws.columns.length)


    // เว้นบรรทัดว่าง
    let rowIndex = 4

    // Header row - กำหนดเองเพื่อความสวยและควบคุมฟอนต์/จัดตำแหน่ง
    const headerRow = ws.getRow(rowIndex)
    headerRow.values = ws.columns.map(col => col.header) as string[]
    headerRow.font = { bold: true }
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
    headerRow.height = 24
    headerRow.eachCell((cell, colNumber) => {
        if ([2, 3].includes(colNumber)) {
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
        } else {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        }

        // Set header background color
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF0F0F0' } // Light grey background
        };
        cell.border = {
            top: { style: 'thin' }, left: { style: 'thin' },
            bottom: { style: 'thin' }, right: { style: 'thin' }
        };
    })
    rowIndex++

    // เพิ่มข้อมูล ลง worksheet
    if (!templateTypes || templateTypes.length === 0) {
        const noDataRow = ws.getRow(rowIndex);
        noDataRow.values = [t('REPORT.TITLE.NO_DATA')];
        ws.mergeCells(rowIndex, 1, rowIndex, ws.columns.length);
        noDataRow.font = { italic: true };
        noDataRow.alignment = { horizontal: 'center' };
    } else {
        templateTypes.forEach((item, index) => {
            const row = ws.addRow({
                no: index + 1,
                templateTypeName: item.treatmentTemplateTypeName,
                templateTypeNameEn: item.treatmentTemplateTypeNameEn,
                status: item.status === "ACTIVE" ? t(`STATUS.ACTIVE`) : t(`STATUS.INACTIVE`),
                updatedBy: `${item.updatedBy}\n${item.updatedAt ? dateTimeToView(item.updatedAt) : ''}`,
            })

            row.height = 35 // Increase row height for wrapped text

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' }, left: { style: 'thin' },
                    bottom: { style: 'thin' }, right: { style: 'thin' }
                }
                // Set alignment and wrapping for data cells
                if (colNumber === 5) { // updatedBy
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                } else if ([2, 3].includes(colNumber)) { // templateTypeName, templateTypeNameEn
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                } else { // no, status
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                }
            })
            rowIndex++
        })
    }

    // สร้างและดาวน์โหลดไฟล์
    const buffer = await wb.xlsx.writeBuffer();
    saveAs(
        new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        `${t('TEMPLATE_TYPE.TITLE')}_${moment().format('YYYYMMDD')}.xlsx`
    );
}

